import React from 'react';
import Image from 'next/image';

import { ActiveLink } from '@/ui/index';

import styles from './news.module.scss';

const News = ({ item }) => {
  return (
    <ActiveLink
      href={`news/${item?.slug}`}
      itemScope
      itemType='https://schema.org/NewsArticle'
    >
      <a
        className={styles.newsItem}
        title={item?.title}
        aria-label={item?.title}
      >
        <div className={styles.imageContainer}>
          <Image
            src={item?.image}
            alt={item?.title}
            title={item?.title}
            layout={'fill'}
            loading='lazy'
          />
        </div>
        <div className={styles.textWrapper}>
          <div className={styles.common}>
            <div className={styles.theme}>{item?.category?.name}</div>
            <div className={styles.title}>{item?.title}</div>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: item?.description,
              }}
            ></div>
          </div>
          <span className={styles.date}>{item?.date}</span>
        </div>
      </a>
    </ActiveLink>
  );
};

export default News;
